'use client'

import { propertyDataLayer } from '@plugin/google/gtm/modules/property'
import { statsAgentPhoneClick } from '@plugin/statistics'
import { blockNumber } from '@utils'
import classNames from 'classnames'
import { get, isFunction } from 'lodash-es'
import { useCallback } from 'react'
import { useBoolean } from 'react-use'

export default function AgentPhoneButton({
  agent,
  data,
  className,
  icon = false,
  full = true,
  onClick,
  children
}) {
  const [displayPhone, togglePhone] = useBoolean(false)
  const showPhone = useCallback((event) => {
    isFunction(onClick) && onClick(event)
    propertyDataLayer.agentPhoneClick()
    togglePhone(true)
    statsAgentPhoneClick(get(agent, 'id'))
  }, [togglePhone, onClick, agent])

  return (
    <a href={`tel:${data}`} className={classNames('button-primary-out', { 'w-full': full }, { 'px-20 justify-between': icon }, className)} onClick={showPhone} data-noprogress>
      {icon && <i className='icon icon-phone'></i>}
      <span className={classNames({ 'flex-1 text-center': icon })}>
        {
          children
            ? children
            : displayPhone ? data : blockNumber(data)
        }
      </span>
    </a>
  )
}